"use strict";

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Fields, System } from "Constants/objects";
import { d5TableFilterSaved } from "Actions/Table/D5TableActions";
import { showSnackBar } from "Actions/D5SnackbarsActions";
import { Model } from "Model";
import { checkIfUserScriptExists, createTableComponentID, createTableID, formatDateToAPI, getAddSSFilter, getSelectFieldData, getSSTableCols, isDateByTypeStr, isEmptyValue, setAddSSFilter, setSSTableCols } from "D5Utils/functions";
import FormFilterEditor from "D5Utils/filter_editor/FormFilterEditor";
import { AppDispatcher } from 'Dispatcher';
import { D5TableConstants } from "Constants/Table/D5TableConstants";
import { tableCustomAction } from "UserActionHandler/UserScriptActions";
import withCaption from "./withCaption";
import { FilterField } from "D5Utils/Objects";

var styles = function styles(theme) {
  return {
    d5FormCaption: {
      fontSize: 20,
      borderBottom: '1px solid #d5d9da',
      paddingBottom: 3,
      margin: '0 2px',
      flex: '0 0 auto'
    },
    filterForm: {
      backgroundColor: '#fff',
      padding: '10px 0'
    }
  };
};

var D5FormLayoutFilters =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(D5FormLayoutFilters, _PureComponent);

  //FormFields
  //FormFilterFields
  function D5FormLayoutFilters(props) {
    var _this;

    _classCallCheck(this, D5FormLayoutFilters);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D5FormLayoutFilters).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "viewSource", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "formFilters", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "editors", new Map());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "editor", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tableUUID", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "sender", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "filterEvents", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "formName", void 0);

    AppDispatcher.register(function (action) {
      switch (action.actionType) {
        case D5TableConstants.D5_UPDATE_LAYOUT_FILTER:
          if (_this.tableUUID === action.formUUID) _this.renderField(action.sender);
          break;
      }
    });
    return _this;
  }

  _createClass(D5FormLayoutFilters, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var options = this.props.options;

      var viewSource = options.viewSource,
          formFilters = options.formFilters,
          filterEvents = options.filterEvents,
          rest = _objectWithoutProperties(options, ["viewSource", "formFilters", "filterEvents"]);

      this.viewSource = viewSource;
      this.formFilters = formFilters || [];
      this.filterEvents = filterEvents || [];
      this.formName = this.viewSource[0][Fields.FormID_Name];
      this.formID = this.viewSource[0][Fields.FormID];
      this.tableUUID = 'FormEditTable-' + this.getLSName(this.formID);
      this.filterField = new FilterField(rest, this.viewSource);
      this.renderField();
    }
  }, {
    key: "getLSName",
    value: function getLSName(formID)
    /*parentFormID, formType*/
    {
      return createTableComponentID(formID, null, System.FORM_TYPE.LIST); // TODO передавать параметр нормально
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {//TODO dispose element
    }
  }, {
    key: "renderField",
    value: function renderField(sender) {
      if (sender === System.FILTER_SENDERS.TABLE) {
        this.sender = sender;
      }

      var addData = this.getLSAdditional();
      var tableData = this.getLSTableData();

      if (sender !== System.FILTER_SENDERS.TABLE) {
        this.initField({
          addData: addData,
          tableData: tableData
        });
      } else {
        var _this$getLSFieldData = this.getLSFieldData({
          addData: addData,
          tableData: tableData
        }),
            value = _this$getLSFieldData.value,
            realOperation = _this$getLSFieldData.realOperation;

        try {
          if (!this.editor) return;
          this.editor.operation(realOperation);
          this.editor.setValue(value);
        } catch (e) {}
      }

      this.sender = System.FILTER_SENDERS.LAYOUT;
    }
    /**
     * @param {Object} addData
     * @param {Map} tableData
     * @param {Object} field FormFilterFields
     * @return {Object}
     */

  }, {
    key: "getLSFieldData",
    value: function getLSFieldData(_ref) {
      var tableData = _ref.tableData,
          addData = _ref.addData;
      var realOperation = '';
      var objFldID = this.filterField.ObjectFieldID;
      var value;

      if (this.filterField.isTableField()) {
        realOperation = tableData.get(objFldID) && tableData.get(objFldID).realOperation;
        value = tableData.get(objFldID) && tableData.get(objFldID).value;
      } else {
        realOperation = addData[this.filterField.Name] && addData[this.filterField.Name].realOperation;
        value = addData[this.filterField.Name] && addData[this.filterField.Name].filterValue;
      }

      return {
        realOperation: realOperation,
        value: value,
        name: this.filterField[Fields.Name]
      };
    }
    /**
     * @return {Map<Number, Object>}
     */

  }, {
    key: "getLSTableData",
    value: function getLSTableData() {
      var lsCols = this.getLSTableCols();
      var out = new Map();

      _.each(lsCols, function (col) {
        var data = {
          index: Number(col.index),
          ObjectFieldID: Number(col.ObjectFieldID),
          Name: col.Name,
          realOperation: col.realOperation,
          allowFiltering: true
        };

        if (col.hasOwnProperty('filterValue')) {
          data.value = col.filterValue;
        }

        out.set(col.ObjectFieldID, data);
      });

      return out;
    }
  }, {
    key: "getLSAdditional",
    value: function getLSAdditional() {
      var lsKey = createTableID(this.formID);
      return getAddSSFilter(lsKey);
    }
  }, {
    key: "getFilterFieldEventNameByField",
    value: function getFilterFieldEventNameByField(fieldID, eventType) {
      var fieldEvent = this.filterEvents.find(function (e) {
        return e[Fields.FormFilterFieldID] === Number(fieldID) && e[Fields.EventTypeID] === eventType;
      });
      if (fieldEvent && fieldEvent[Fields.FunctionName]) return fieldEvent[Fields.FunctionName];
    }
  }, {
    key: "initField",
    value: function initField(_ref2) {
      var _this2 = this;

      var addData = _ref2.addData,
          tableData = _ref2.tableData;
      var dataField = this.filterField.Name;

      var _ref3 = this.getLSFieldData({
        tableData: tableData,
        addData: addData
      }) || {},
          realOperation = _ref3.realOperation,
          value = _ref3.value;

      var typeField = this.filterField.getFieldType();
      var dictObj = this.filterField.getLinkedName();
      var dictKeyFld = this.filterField.getKeyObjFieldName();
      var dictDisplayFld = this.filterField.getDisplayObjectFieldIDName();

      var type = function () {
        switch (typeField) {
          case System.DX_CONTROLS.dxCheckBox:
            return System.FIELD_EDITOR_TYPE.BOOL_CB;

          case System.DX_CONTROLS.dxNumberBox:
            return System.FIELD_EDITOR_TYPE.NUMBER;

          case System.DX_CONTROLS.dxDateBox:
            {
              return System.FIELD_EDITOR_TYPE.DATE;
            }

          case System.DX_CONTROLS.dxTextBox:
            return System.FIELD_EDITOR_TYPE.TEXT;

          case System.DX_CONTROLS.dxTagBox:
            return System.FIELD_EDITOR_TYPE.MULTI_SELECT;

          case System.DX_CONTROLS.dxSelectBox:
            return System.FIELD_EDITOR_TYPE.SELECT;
        }
      }();

      var props = {
        objectName: this.filterField.formIDObjectIDName,
        dataField: this.filterField.Name,
        dType: type,
        _id: "form-filter-".concat(dataField),
        dataSource: this.createSelectFieldDS({
          dictObj: dictObj,
          dictKeyFld: dictKeyFld,
          dictDisplayFld: dictDisplayFld
        }),
        displayExpr: dictDisplayFld,
        valueExpr: dictKeyFld,
        value: value,
        onValueChanged: function onValueChanged(_ref4) {
          var value = _ref4.value;
          var tableField = _this2.filterField.tableField;

          if (_this2.sender !== System.FILTER_SENDERS.TABLE) {
            var eventName = _this2.getFilterFieldEventNameByField(_this2.filterField.ID, System.USER_EVENT_TYPE.ON_VALUE_CHANGED);

            var _this2$prepareData = _this2.prepareData(),
                lsColumns = _this2$prepareData.lsColumns,
                addFilter = _this2$prepareData.addFilter;

            if (tableField) {
              var lsCol = _.find(lsColumns, function (c) {
                return c.dataField === tableField.Name;
              });

              lsCol.filterValue = value;
            } else {
              if (addFilter[dataField]) {
                addFilter[dataField].filterValue = value;
              } else {
                addFilter[dataField] = {
                  realOperation: '=',
                  filterValue: value
                };
              }
            }

            if (eventName && checkIfUserScriptExists(_this2.formName, eventName)) {
              _this2.emitFilterFieldUserEvent({
                eventName: eventName,
                lsColumns: lsColumns,
                addFilter: addFilter,
                formUUID: _this2.tableUUID
              });

              return;
            }

            _this2.validate().then(function () {
              _this2.saveFilter(lsColumns, addFilter);
            }).catch(function (error) {
              _this2.saveFilter(lsColumns, addFilter);

              if (error.message) {
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: error.message
                });
              }
            });
          }
        }
      };
      this.editor = new FormFilterEditor({
        defOperation: realOperation,
        type: type,
        onOperationChanged: function onOperationChanged(operation) {
          if (_this2.sender === System.FILTER_SENDERS.LAYOUT) {
            var _this2$prepareData2 = _this2.prepareData(),
                lsColumns = _this2$prepareData2.lsColumns,
                addFilter = _this2$prepareData2.addFilter;

            _this2.saveFilter(lsColumns, addFilter);
          }
        }
      }, props);
      this.editor.render();
      $(this.fieldEl).append(this.editor.element());

      if (this.filterField.required || this.filterField.title === 'Цена') {
        this.withValidator();
      }
    }
  }, {
    key: "emitFilterFieldUserEvent",
    value: function emitFilterFieldUserEvent(_ref5) {
      var eventName = _ref5.eventName,
          formUUID = _ref5.formUUID,
          rowIndex = _ref5.rowIndex,
          lsColumns = _ref5.lsColumns,
          addFilter = _ref5.addFilter;
      tableCustomAction({
        fileName: this.formName,
        funcName: eventName,
        nextStore: {},
        viewStore: this.viewSource,
        rowIndex: -1,
        formUUID: formUUID,
        props: {
          filter: {
            formFields: this.viewSource,
            viewSource: this.formFilters,
            lsColumns: lsColumns,
            addFilter: addFilter
          }
        }
      });
    }
  }, {
    key: "getLSName",
    value: function getLSName() {
      return createTableID(this.formID);
    }
  }, {
    key: "createSelectFieldDS",
    value: function createSelectFieldDS(options) {
      var dictObj = options.dictObj,
          dictKeyFld = options.dictKeyFld,
          dictDisplayFld = options.dictDisplayFld;
      if (!(dictObj && dictKeyFld && dictDisplayFld)) return;
      return new DevExpress.data.DataSource({
        paginate: true,
        pageSize: 10,
        store: new DevExpress.data.CustomStore({
          load: function load(loadOptions) {
            return getSelectFieldData(loadOptions, dictObj, dictKeyFld, dictDisplayFld);
          },
          byKey: function byKey(key) {
            if (Array.isArray(key) && !key.length) return Promise.resolve();
            return new Promise(function (resolve) {
              var ObjectModel = Model.extend({
                initialize: function initialize() {
                  this.object = dictObj;
                }
              });
              new ObjectModel().fetch({
                data: {
                  Columns: [dictKeyFld, dictDisplayFld],
                  Filters: _defineProperty({}, dictKeyFld, {
                    '=': key
                  }),
                  Sorts: [dictDisplayFld]
                },
                success: function success(res) {
                  resolve(res.toJSON());
                }
              });
            });
          }
        })
      });
    }
  }, {
    key: "withValidator",
    value: function withValidator() {
      $(this.editor.element().find('.d5-field')).dxValidator({
        validationRules: [{
          type: "required",
          message: "".concat(this.filterField.title, " is required")
        }],
        validationGroup: 'layout_filter'
      });
    }
  }, {
    key: "validate",
    value: function validate() {
      // let message = this.getValidationFormData();
      // if (message)
      //     return Promise.reject(new Error(message));
      //TODO сделать валидацию для поля
      return Promise.resolve();
    }
  }, {
    key: "innerValidate",
    value: function innerValidate(instance) {
      try {
        var validation = DevExpress.validationEngine.validateGroup(instance);
        return validation ? validation.brokenRules : [];
      } catch (e) {
        return [];
      }
    }
  }, {
    key: "getValidationFormData",
    value: function getValidationFormData() {// let isValid = [...this.innerValidate(this.instance())];
      //
      // return isValid.map(item => item.message).join('<br/>');
    }
  }, {
    key: "getLSTableCols",
    value: function getLSTableCols() {
      return getSSTableCols(this.getLSName());
    }
  }, {
    key: "prepareData",
    value: function prepareData() {
      var lsKey = createTableID(this.formID);
      var lsColumns = getSSTableCols(lsKey);
      var addFilter = getAddSSFilter(lsKey);
      var tableField = this.filterField.tableField;
      var dataField = this.filterField.Name;
      var realOperation = this.editor.operation();
      var filterValue = this.editor.getValue();

      if (isDateByTypeStr(this.editor.type())) {
        if (Array.isArray(filterValue)) {
          filterValue = filterValue.map(function (date) {
            return formatDateToAPI(new Date(date));
          });
        } else {
          if (filterValue != null) filterValue = formatDateToAPI(new Date(filterValue));
        }
      } else if (this.editor.type() === 'boolean') {
        filterValue = filterValue != null ? Number(filterValue) : filterValue;
      }

      if (tableField) {
        var col = this.getLSColumnByName(lsColumns, tableField.Name);
        col.realOperation = realOperation;
        col.filterValue = filterValue;
      } else {
        if (addFilter[dataField]) {
          if (isEmptyValue(filterValue)) {
            delete addFilter[dataField];
          } else {
            addFilter[dataField].filterValue = filterValue;
          }
        } else {
          if (!isEmptyValue(filterValue)) {
            addFilter[dataField] = {
              realOperation: realOperation,
              filterValue: filterValue
            };
          }
        }
      }

      return {
        lsColumns: lsColumns,
        addFilter: addFilter
      };
    }
  }, {
    key: "getLSColumnByName",
    value: function getLSColumnByName(lsCols, name) {
      return lsCols.find(function (col) {
        return col.dataField === name;
      });
    }
  }, {
    key: "saveFilter",
    value: function saveFilter(lsColumns, addFilter) {
      var lsKey = createTableID(this.formID);
      lsColumns.forEach(function (col) {
        if (isEmptyValue(col.filterValue)) delete col.filterValue;
      });
      setSSTableCols(lsKey, lsColumns);
      setAddSSFilter(lsKey, addFilter);
      d5TableFilterSaved({
        formUUID: this.tableUUID,
        sender: System.FILTER_SENDERS.LAYOUT
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          id = _this$props.id,
          itemType = _this$props.itemType;
      return React.createElement("div", {
        className: "dx-field-value",
        id: "d5-layout-".concat(itemType, "-").concat(id),
        ref: function ref(r) {
          return _this3.fieldEl = r;
        },
        style: {
          width: '100%'
        }
      });
    }
  }]);

  return D5FormLayoutFilters;
}(PureComponent);

export default withCaption(withStyles(styles)(D5FormLayoutFilters));